module.exports = __webpack_public_path__ + "img/w3_filter_grey.a82ddd41.png";